import { r as requiredActionProviderRepresentation } from '../../../../common/requiredActionProviderRepresentation-0979d22c.js';
import '../../../../common/_commonjsHelpers-7446a541.js';



var RequiredActionAlias = requiredActionProviderRepresentation.RequiredActionAlias;
export { RequiredActionAlias };
